import React from 'react';
import {Input, Select, Form, Modal, DatePicker,Upload,message,Button,Icon,Col,Row,Drawer,Descriptions,Badge,Statistic} from 'antd';
import moment from 'moment';

const PurRecordOrderDetail =(props)=>{
	
	const {onCancel,visible,item} =props
	
	let width = window.innerWidth <768 ? window.innerWidth*0.8 :window.innerWidth*0.35
	return (
	
	<Drawer   title={item.engineering_name?<span>项目名称:{item.engineering_name}</span>:<span>无项目名称</span>}     placement="right"      closable={false}      onClose={onCancel}    visible={visible}  width={width}  >

	  	<Descriptions title="商品信息" layout="vertical" bordered>		
		<Row><Col span={24}><pre style={{ margin: 0, textAlign: 'left' }}>
                 {JSON.stringify(item.goodsList,null , 2)}<br/><br/><br/>
                  </pre></Col>				 
                 </Row>
	  </Descriptions>
      </Drawer>
	
	)

}


export default PurRecordOrderDetail;
